export default __webpack_public_path__ + "static/media/gift_card.3c934296.png";